module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "size": _vm.size,
      "clearable": true,
      "placeholder": _vm.placeholder,
      "remote-method": _vm.query,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.updateValue
    },
    model: {
      value: (_vm.invalue),
      callback: function($$v) {
        _vm.invalue = $$v
      },
      expression: "invalue"
    }
  }, _vm._l((_vm.list), function(it) {
    return _c('el-option', {
      attrs: {
        "value": it[_vm.valueField],
        "label": it[_vm.textField]
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-47057db9!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/xelement/select_remote.vue
// module id = 220
// module chunks = 2